import {SearchProvider} from "@buildwithflux/constants";
import {isProductionEnvironment} from "@buildwithflux/shared";

import {normalizedAndOperator} from "../adapters";

/**
 * Function to generate filter string for test_data, taking searchProvider
 * into account
 */
export function filterTestData(and: boolean, searchProvider: SearchProvider) {
    if (isProductionEnvironment()) {
        if (and) {
            return `${normalizedAndOperator(searchProvider)} test_data:false`;
        }
        return `test_data:false`;
    }
    return "";
}

export function filterSeoBannedUsers(and: boolean, searchProvider: SearchProvider) {
    // Filter out SEO-banned users (all ban-like statuses), unreviewed users (seo: "not_reviewed"), and soft-deleted users (seo: "removed")
    if (and) {
        return `${normalizedAndOperator(searchProvider)} seo:!=banned ${normalizedAndOperator(
            searchProvider,
        )} seo:!=auto_banned ${normalizedAndOperator(searchProvider)} seo:!=pending_review ${normalizedAndOperator(
            searchProvider,
        )} seo:!=removed ${normalizedAndOperator(searchProvider)} seo:!=not_reviewed`;
    }
    return `seo:!=banned && seo:!=auto_banned && seo:!=pending_review && seo:!=removed && seo:!=not_reviewed`;
}

export function filterSeoBannedOrganizations(and: boolean, searchProvider: SearchProvider) {
    if (and) {
        return `${normalizedAndOperator(searchProvider)} seo:!=banned ${normalizedAndOperator(
            searchProvider,
        )} seo:!=auto_banned ${normalizedAndOperator(searchProvider)} seo:!=pending_review ${normalizedAndOperator(
            searchProvider,
        )} seo:!=not_reviewed`;
    }
    return `seo:!=banned && seo:!=auto_banned && seo:!=pending_review && seo:!=not_reviewed`;
}
